<template>
  <ContentBlock class="staistics-panel">
    <el-tabs v-model="active">
      <el-tab-pane label="企业数据" name="company"></el-tab-pane>
      <el-tab-pane label="用户数据" name="personal"></el-tab-pane>
    </el-tabs>
    <template v-if="active === 'company'">
      <Company />
    </template>
    <template v-if="active === 'personal'">
      <Personal />
    </template>
  </ContentBlock>
</template>
<script>
import Company from './components/company.vue';
import Personal from './components/personal.vue';
export default {
  components: {
    Company,
    Personal,
  },
  data () {
    return {
      active: 'company',
    };
  },
};
</script>
<style lang="scss" scoped>
.staistics-panel {
  /deep/ .el-tabs__header {
    margin-bottom: 5px;
  }
}
</style>
